// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2No7r","content":"styles_content__3nVV5","selectAll":"styles_selectAll__3QRzT"};